module.exports = __webpack_public_path__ + "img/catering_menu_15.c38794eb.jpg";